export const COUNT = {
  count1: {
    number: 137,
    caption: 'Our Projects',
    icon: 'bi-stack',
  },
  count2: {
    number: 112,
    caption: 'Happy Clients',
    icon: 'bi-people',
  },
  count3: {
    number: 1067,
    caption: 'Cups of Coffee',
    icon: 'bi-water',
  },
  count4: {
    number: 20531,
    caption: 'Line of Code',
    icon: 'bi-code-square',
  },
};